import { useRoomRoomCheckIn } from "@crowdcoursing/api/openapi";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { useToast } from "~hooks/useToast";
import { Route } from "~services/router/Route";
import { valueOrFallback } from "~utils/sanitizeDto";

const tCheckingIn = "Checking in...";
const tCheckInSuccess = "You have been checked in";

/** @deprecated We are phasing out `components/**` */
export const CheckIn = () => {
  const { roomId } = useParams();
  const navigate = useNavigate();
  const toast = useToast();
  const { mutate: checkIn } = useRoomRoomCheckIn({
    onSuccess() {
      navigate(
        Route.roomView({
          roomId: valueOrFallback(roomId, "MISSING_ROOM_ID", "(CheckIn) Missing roomId in url params"),
        }),
      );
      toast.success(tCheckInSuccess);
    },
  });

  useEffect(() => {
    checkIn({
      pathParams: { roomId: valueOrFallback(roomId, "MISSING_ROOM_ID", "(CheckIn) Missing roomId in url params") },
    });
  }, [checkIn, roomId]);

  return <>{tCheckingIn}</>;
};
